export default __webpack_public_path__ + "static/room_b.5f116d737387af5d092c9fe3bd8194a0.png";